/**
 * Andre Garen - Anasayfa Abiye bolumunde "?occasion=<handle>" ile gelindiginde
 * "Seckin Abiyeler" seckisini o davetin GERCEK koleksiyonuyla degistirir.
 * Davet secici artik /?occasion=<handle>#ag-two-worlds adresine yonlendiriyor;
 * bu script gercek /collections/<handle>.json ve /products.json verisini ceker.
 */
(function () {
  'use strict';

  var params = new URLSearchParams(location.search);
  var handle = params.get('occasion');
  if (!handle) return;

  var rail = document.querySelector('[data-ag-occasion-rail]');
  var chip = document.querySelector('[data-ag-occasion-chip]');
  var chipLabel = chip && chip.querySelector('[data-ag-occasion-chip-label]');
  var countEl = document.querySelector('[data-ag-world-count]');
  if (!rail) return;

  var defaultHandle = rail.getAttribute('data-ag-occasion-default-collection');
  if (handle === defaultHandle) return;

  function fmtMoney(cents) {
    /* Denetim (P1 backlog madde 2 sirasinda fark edildi): binlik ayirici
       virgul kullaniyordu ("13,970 ₺") - TRY icin sitenin geri kalaninin
       (money_without_trailing_zeros, bkz. ag-price.liquid) kullandigi
       nokta-binlik/virgul-ondalik bicime ("13.970 ₺") ters dusuyordu. */
    var whole = Math.round(cents) % 100 === 0;
    var v = whole ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2).replace('.', ',');
    var parts = v.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (parts[1] ? parts.join(',') : parts[0]) + ' ₺';
  }

  Promise.all([
    fetch('/collections/' + handle + '.json').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
    fetch('/collections/' + handle + '/products.json?limit=4').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
  ]).then(function (res) {
    var colData = res[0] && res[0].collection;
    var prodData = res[1] && res[1].products;
    if (!colData || !prodData) return;

    if (chip && chipLabel) {
      chipLabel.textContent = colData.title;
      chip.setAttribute('data-shown', '1');
      var clearHref = chip.getAttribute('data-ag-occasion-clear-href');
      chip.addEventListener('click', function () {
        window.location.href = clearHref || '/';
      });
    }

    if (countEl) {
      var suffix = countEl.textContent.replace(/^[\d.,]+\s*/, '');
      countEl.textContent = prodData.length + ' ' + suffix;
    }

    if (!prodData.length) {
      rail.innerHTML = '';
      return;
    }

    rail.innerHTML = prodData.map(function (p, i) {
      var v = p.variants && p.variants[0];
      var price = v ? fmtMoney(Math.round(parseFloat(v.price) * 100)) : '';
      var compareAt = v && parseFloat(v.compare_at_price) > parseFloat(v.price) ? fmtMoney(Math.round(parseFloat(v.compare_at_price) * 100)) : '';
      var img = p.images && p.images[0] ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var num = String(i + 1).padStart(2, '0');
      /* Denetim (P1 backlog madde 3, fix A): eskiden bu kartlarda data-ag-tags
         hic yoktu - ag-home-highlights.js'in cardsFor() taramasi bu rayi
         BOS buluyordu, header'daki highlight filtresi occasion secimi
         sonrasi gorsel olarak basili gorunup hicbir seyi filtrelemiyordu.
         /collections/<handle>/products.json cevabi urunun TAM koleksiyon
         listesini vermiyor (sadece tags string'i) - ama bu rayin TUMU zaten
         "handle" koleksiyonundan geldigi icin en azindan o koleksiyonun
         kendi highlight etiketiyle (ag-header.liquid'deki night_category
         bloklarinda block.settings.collection.handle) eslesmesi garanti
         ediliyor - ag-product-card.liquid'deki tam esdegeri degil ama
         mevcut REST verisiyle ulasilabilecek en dogru yaklasim. */
      var dataTags = (handle + ',' + (p.tags || ''))
        .split(',')
        .map(function (t) { return t.trim(); })
        .filter(Boolean)
        .join('|')
        .toLowerCase()
        .replace(/"/g, '&quot;');
      return (
        '<article class="ag-card ag-card--night" data-ag-tags="' + dataTags + '">' +
        '<a class="ag-card__media" href="/products/' + p.handle + '">' +
        (img ? '<img class="ag-card__img" src="' + img + '" loading="lazy" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') +
        '<span class="ag-card__num">' + num + '</span>' +
        '</a>' +
        '<div class="ag-card__body">' +
        '<a class="ag-card__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
        '<span class="ag-price">' +
        (compareAt && compareAt !== price ? '<span class="ag-price__was">' + compareAt + '</span>' : '') +
        '<span class="ag-price__now">' + price + '</span>' +
        '</span>' +
        '</div>' +
        '</article>'
      );
    }).join('');
  });
})();
